(function metadataModuleDefinition() {
    'use strict';

    angular.module('Metadata', ['ui.router', 'Config', 'Entities', 'ErrorsExtend', 'ClickOnce'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function metadataConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('metadata-modify', {
                    url: "/Metadata/Modify/{id}",
                    templateUrl: config.resourceUrl('/views/metadata/add-modify.html'),
                    controller: 'MetadataModifyController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PROCESSMETADATA WRITE')
                });

                $stateProvider.state('metadata-detail', {
                    url: "/Metadata/Detail/{id}",
                    templateUrl: config.resourceUrl('/views/metadata/detail.html'),
                    controller: 'MetadataDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PROCESSMETADATA READ').or('PROCESSMETADATA WRITE')
                });

                $stateProvider.state('metadata-find', {
                    url: "/Metadata/List",
                    templateUrl: config.resourceUrl('/views/metadata/list.html'),
                    controller: 'MetadataFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('PROCESSMETADATA READ').or('PROCESSMETADATA WRITE')
                });
            }
        ]);
})();